import styled from 'styled-components';
import { AccessibleHeaderElement } from './accessible-header';

export const AccessibleHeader = styled(AccessibleHeaderElement)`
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;
